module.exports = __webpack_public_path__ + "static/media/CustomerChampions.7b6ca80f.svg";